//@ts-nocheck TS6133
/* eslint-disable @typescript-eslint/no-duplicate-imports */
import type * as Types from 'owa-graph-schema';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { BookingSettingsFragmentFragmentDoc } from '../../fragments/__generated__/BookingSettingsFragment.interface';
export type UpdateBookingBusinessPageMutationVariables = Types.Exact<{
    businessEntry?: Types.InputMaybe<Types.BookingBusinessEntryInput>;
}>;
export type UpdateBookingBusinessPageMutation = {
    __typename?: 'Mutation';
    updateBookingBusiness?: {
        __typename?: 'UpdateBookingBusinessResponse';
        businessEntry?: {
            __typename?: 'BookingBusinessEntry';
            settings?: {
                __typename?: 'BookingSettings';
                otpVerificationSetting?: Types.BookingOtpSettings | null;
                publishingUrl?: string | null;
                c2RevampedEnabled?: boolean | null;
                authType?: Types.BookingSelfServicePageAuthType | null;
                friendlyUrl?: string | null;
                isLogoHidden?: boolean | null;
                isConsentNeeded?: boolean | null;
                consentText?: string | null;
                customColorScheme?: string | null;
                isSearchEngineIndexabilityDisabled?: boolean | null;
                showTimeSlotsInBusinessTimeZone?: boolean | null;
                emailVerificationMethod?: Types.BookingEmailVerificationMethod | null;
                sendMeetingInviteToCustomer?: boolean | null;
                onDemandServicesSetting?: Types.BookingOnDemandServicesSettings | null;
                themeData?: {
                    __typename?: 'BookingThemeData';
                    paletteId?: number | null;
                    patternId?: number | null;
                    pictureId?: number | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export const UpdateBookingBusinessPageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateBookingBusinessPage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'businessEntry' } },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'BookingBusinessEntryInput' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateBookingBusiness' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'request' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'businessEntry' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'businessEntry' },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'businessEntry' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'settings' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'BookingSettingsFragment',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BookingSettingsFragmentFragmentDoc.definitions,
    ],
} as unknown as DocumentNode<
    UpdateBookingBusinessPageMutation,
    UpdateBookingBusinessPageMutationVariables
>;
